import { render, staticRenderFns } from "./RatingDetail.vue?vue&type=template&id=546f4c66"
import script from "./RatingDetail.vue?vue&type=script&lang=js"
export * from "./RatingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports